// extracted by mini-css-extract-plugin
export default {"container":"MethodDistributionChart_container__UD3Xq","emptyState":"MethodDistributionChart_emptyState__ze3zA","emptyText":"MethodDistributionChart_emptyText__18YH2"};